import { render } from "./Agreement.vue?vue&type=template&id=30bc6bc0&scoped=true"
import script from "./Agreement.vue?vue&type=script&lang=js"
export * from "./Agreement.vue?vue&type=script&lang=js"

import "./Agreement.vue?vue&type=style&index=0&id=30bc6bc0&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bc6bc0"]])

export default __exports__